import { Autocomplete, Box, InputAdornment, TextField } from '@mui/material';

import IconComponent, { getAvailableIconNames } from './IconComponent';

type IconSelectorInputProps = {
	value: string | undefined;
	onValueChange: (value: string | undefined) => void;
	label?: string;
	placeholder?: string;
	required?: boolean;
	fullWidth?: boolean;
	variant?: 'standard' | 'outlined' | 'filled';
};

const ICON_OPTIONS = getAvailableIconNames();

export default function IconSelectorInput({
	value,
	onValueChange,
	label = 'Icon',
	placeholder,
	required,
	fullWidth = true,
	variant = 'outlined',
}: IconSelectorInputProps) {
	return (
		<Autocomplete
			value={value || null}
			onChange={(_, newValue) => onValueChange(newValue || undefined)}
			options={ICON_OPTIONS}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					placeholder={placeholder}
					required={required}
					variant={variant}
					slotProps={{
						input: {
							...params.InputProps,
							startAdornment: value ? (
								<>
									<InputAdornment position="start" sx={{ mr: 0.5 }}>
										<IconComponent iconName={value} />
									</InputAdornment>
									{params.InputProps.startAdornment}
								</>
							) : (
								params.InputProps.startAdornment
							),
						},
					}}
				/>
			)}
			renderOption={(props, option) => {
				const { key, ...otherProps } = props as any;
				return (
					<Box component="li" key={key} {...otherProps} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						<IconComponent iconName={option} />
						<span>{option}</span>
					</Box>
				);
			}}
			fullWidth={fullWidth}
			size="small"
			clearOnBlur
			selectOnFocus
			handleHomeEndKeys
		/>
	);
}
